import React, { useContext, useEffect } from 'react';
import { IsMobileBiggerWidth } from 'core/util/WindowSize';
import GlobalStyled from './../../AcessoExlusivo.style';
import { AcessoExclusivoContext } from 'pages/acessoExclusivo/context/AcessoExclusivoContext';
import Loading from 'components/Loading';
import OverviewExclusivo from '../components/OverviewExclusivo';
import CicloExclusivo from '../components/CicloExclusivo';
import seLigaLogo from './../../../../images/solutions/logo/seLigaLogo.png';
import MateriaisExclusivos from '../components/MateriasExclusivos';
import { ListMateriasSeLigaPlanoAnual } from './ListMateriasSeLiga';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import UsuarioDTO from 'models/UsuarioDTO';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import SessionFerramentaVideo from 'pages/acessoExclusivo/components/SessionFerramentaVideo';

const SeLigaPrivate = () => {
    const { loading, idsMyCategorias } = useContext(AcessoExclusivoContext.Context);
    const isMobile = IsMobileBiggerWidth();
    const usuarioLogado: UsuarioDTO = useAppSelector(state => state.authenticationReducer.usuarioLogado);
    const isApoioCultura = idsMyCategorias.some(id => id === 35) && !usuarioLogado.email.includes('@ias');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <GlobalStyled.GlobalContainer isMobile={isMobile}>
            {loading ? (
                <>
                    <Loading />
                </>
            ) : (
                <>
                    <OverviewExclusivo
                        isBlue
                        mencao={
                            [2, 3, 4, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Ministério da Cultura apresenta o projeto Plano Anual Instituto Ayrton Senna.'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Ministério da Cultura apresenta o projeto Apoio Cultural e Educacional para Escolas das Redes Públicas Estadual e Municipal do Instituto Ayrton Senna.'
                                : ''
                        }
                        title="Se Liga"
                        img="ExclusivoSeLigaImagem1.jpg"
                        logo={seLigaLogo}
                        arquivo={'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Visão Geral_Se Liga.pdf'}
                        nome_arquivo="Se_Liga_Visao_Geral"
                        description={`
                        O <b>Se Liga</b> é uma iniciativa pensada para alfabetizar estudantes com distorção idade-ano, matriculados do 3º ao 5º ano do Ensino Fundamental. 
                        A proposta é garantir a esses alunos as condições necessárias para seguir aprendendo, com mais segurança e continuidade em sua trajetória escolar. <br/><br/>
                        Para isso, o programa foca em cinco componentes fundamentais no processo de alfabetização: <br/><br/>
                          <ol style="list-style: inside;">
                            <li><b>Consciência fonológica:</b> desenvolver a percepção dos sons da fala e sua relação com a escrita. </li>
                            <li><b>Princípio alfabético:</b> compreender que as letras representam os sons da fala.</li>
                            <li><b>Fluência na leitura:</b> ganhar ritmo, precisão e expressividade ao ler.</li>
                            <li><b>Vocabulário:</b> ampliar o repertório de palavras para se comunicar melhor.</li>
                            <li><b>Compreensão:</b> entender e interpretar o que se lê.</li>
                          </ol>
                          <br/>
                          O Se Liga reconhece os diferentes tempos de aprendizagem e aposta em estratégias que respeitam cada estudante, promovendo avanços reais no processo de alfabetização. 
                          Acesse o documento de visão geral para saber mais. 
                        `}
                        regua={
                            [2, 3, 4, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Reguas_Logo/2026_Regua_Plano_Anual_Defeso_Eleitoral_pequena.jpg'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Reguas_Logo/2026_Regua_Roanet_Disseminacao_Hor_apoio_comprimida.jpg'
                                : ''
                        }
                        //isButtonHidden={[1, 2].some(id => idsMyCategorias.includes(id)) ? true : false}
                    />
                    {/* ultima frase    .*/}

                    <CicloExclusivo
                        title="Curso Se Liga"
                        description={`
                         O curso <b>Se Liga</b> foi criado para apoiar professores, coordenadores pedagógicos, diretores e técnicos das redes públicas de ensino na compreensão e aplicação dos conteúdos centrais da 
                         solução educacional. 
                        <br/><br/>
                        Ao longo da formação, você vai se apropriar das bases teóricas e práticas necessárias para colocar a proposta em ação, respeitando os tempos e trajetórias de aprendizagem dos estudantes. 
                        <br/><br/>
                        <b>Vamos juntos nessa jornada?</b> <br/>
                        Inicie agora o curso e conheça cada etapa da proposta! 
                        `}
                        img="ExclusivoSeLigaImagem2.jpg"
                        itens={
                            [9, 10, 13, 14, 16].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? [
                                      {
                                          title: 'Curso Se Liga',
                                          url: '/cursos/seliga/se-liga-na-alfabetizacao?redirect=exclusivo/se-liga',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso formativo não está disponível.`,
                                      },
                                      {
                                          title: 'Aprenda a usar a Farol',
                                          url: '/cursos/farol/seliga-farol?redirect=exclusivo/se-liga',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                  ]
                                : [
                                      {
                                          title: 'Curso Se Liga',
                                          url: isApoioCultura
                                              ? '/cursos/seligal/se-liga-na-alfabetizacao-apoio-cultural'
                                              : '/cursos/seliga/se-liga-na-alfabetizacao?redirect=exclusivo/se-liga',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso formativo não está disponível.`,
                                      },
                                  ]
                        }
                    />

                    <MateriaisExclusivos
                        title="Materiais especiais para download"
                        description={`
                            <p>Acesse os materiais exclusivos do <b>Se Liga</b> e conheça mais de perto a proposta. Eles foram pensados para apoiar sua prática e facilitar a implementação da solução na rede. 
                            Explore os conteúdos e comece a desenhar, desde já, os próximos passos rumo à alfabetização de todos os estudantes.<p/>
                            <p>Os materiais de Matemática que são disponibilizados nesta página não contam com incentivo da Lei Rouanet. Todos foram produzidos exclusivamente pelo Instituto Ayrton Senna.</p>
                            `}
                        img={'anexo_storage_files_6046829472028057879.jpg_2025-03-27-1743101575344.jpg'}
                        items={ListMateriasSeLigaPlanoAnual}
                    />
                    <SessionFerramentaVideo solucaoId={3} />
                    <ContactContainer />
                </>
            )}
        </GlobalStyled.GlobalContainer>
    );
};

export default SeLigaPrivate;
